import { createAction } from '@reduxjs/toolkit'

// Global reset action - dispatch this on logout to reset all slices to initial state
export const resetStore = createAction('RESET_STATE')
